var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import EInput from '@common/ui/EInput.vue';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent(__assign({
    inheritAttrs: false
}, { __name: 'ESearch', props: /*#__PURE__*/ _mergeModels({
        placeholder: { default: 'Поиск' },
        theme: {},
        clearable: { type: Boolean, default: true },
        positionError: {}
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }), emits: /*#__PURE__*/ _mergeModels(['clear'], ["update:modelValue"]), setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var searchRef = ref();
        var handleFocusParent = function (e) {
            if (searchRef.value) {
                e.stopPropagation();
                searchRef.value.focus();
            }
        };
        var modelValue = _useModel(__props, "modelValue");
        var handleClearSearch = function () {
            emit('clear');
        };
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([[
                        modelValue.value === '' ? 'e-search-input--empty' : '',
                    ], "e-search-input"]),
                onClick: handleFocusParent
            }, [
                _createVNode(EInput, _mergeProps(_ctx.$attrs, {
                    ref_key: "searchRef",
                    ref: searchRef,
                    modelValue: modelValue.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((modelValue).value = $event); }),
                    clearable: _ctx.clearable,
                    placeholder: _ctx.placeholder,
                    position: _ctx.positionError,
                    theme: _ctx.theme,
                    onClear: handleClearSearch
                }), {
                    prepend: _withCtx(function () { return [
                        _createVNode(_component_e_icon, {
                            class: "text-gray-300 w-3.5 h-3.5",
                            icon: "search"
                        })
                    ]; }),
                    _: 1
                }, 16, ["modelValue", "clearable", "placeholder", "position", "theme"])
            ], 2));
        };
    } }));
